import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { MIDTOWN_POCKETS, NEARBY_GUIDES } from './midtownData';

const toId = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const MidtownNeighborhoods = () => (
  <section className="py-20" data-testid="midtown-neighborhoods">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <p className="text-xs tracking-[0.25em] uppercase text-rose-600">Who comes in</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-serif text-gray-900">Your neighborhood massage therapist in Midtown.</h2>
        <p className="mt-4 text-gray-700 leading-relaxed">
          Most of the people on my table live or work within a few blocks: state workers on their lunch break, Sutter nurses after a long shift, and neighbors who just want an hour to themselves.
        </p>
        <ul className="mt-8 flex flex-wrap gap-3">
          {MIDTOWN_POCKETS.map((p) => (
            <li key={p} className="bg-teal-50 text-teal-800 border border-teal-200 px-4 py-2 rounded-full text-sm hover:-translate-y-0.5 transition-transform duration-300" data-testid={`midtown-pocket-${toId(p)}`}>{p}</li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-7">
        <p className="text-sm text-gray-600 mb-4">Coming from a little further? I wrote a guide for your neighborhood:</p>
        <div className="grid sm:grid-cols-3 gap-4">
          {NEARBY_GUIDES.map((g) => (
            <Link key={g.to} to={g.to} className="group bg-white border border-gray-200 rounded-2xl p-5 hover:border-teal-500 hover:shadow-lg transition-[border-color,box-shadow] duration-300" data-testid={`midtown-nearby-${toId(g.name)}`}>
              <p className="font-serif text-lg text-gray-900">{g.name}</p>
              <p className="mt-1 text-xs text-gray-500 flex items-center gap-1 group-hover:text-teal-700 transition-colors duration-300">Read the guide <ArrowUpRight className="w-3.5 h-3.5" /></p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default MidtownNeighborhoods;
